import React from "react";

const LABEL_CELL_STYLE = { width: "46%" };
const VALUE_CELL_STYLE = { textAlign: "right", verticalAlign: "top" };

const GrnDetailsSummaryTable = ({ rows }) => {
  if (!rows?.length) {
    return null;
  }

  const sortedRows = [...rows].sort((a, b) => a.index - b.index);

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <tbody>
        {sortedRows.map((row, index) => {
          const padding = index === sortedRows.length - 1 ? 0 : "0 0 12px 0";
          return (
            <tr key={row.index}>
              <td
                className="fs-12 fw-400 text-gray-cool"
                style={{ ...LABEL_CELL_STYLE, padding }}
              >
                {row.label}
              </td>
              <td className="fs-14 fw-600" style={{ ...VALUE_CELL_STYLE, padding }}>
                {row.value}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default GrnDetailsSummaryTable;
